angular.module('zc.projects')

.directive 'campaignKpiView', [ "$state", "Campaign", ($state, Campaign) ->
  return {
    restrict: 'A'
    require: '?ngModel'
    scope: {
      cumulativeData: "=ngModel"
    }
    templateUrl: '/templates/projects.campaigns/views/directives/kpi_view.html'

    compile: (tElem, attrs) ->

      return (scope, element, attrs) ->
        scope.Campaign = Campaign
  }

]




// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.campaigns/directives/campaign_kpi_view.js.coffee